import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { config } from '../config';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const apiUrl = config.apiUrl;
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [banners, setBanners] = useState([]);
  const [pixel, setPixel] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // সমস্ত ডেটা একসাথে ফেচ করার ফাংশন
  const fetchAllData = async () => {
    try {
      setLoading(true);
      const [productsRes, categoriesRes, pixelRes, bannersRes] = await Promise.all([
        axios.get(`${apiUrl}/products`),
        axios.get(`${apiUrl}/category`),
        axios.get(`${apiUrl}/pixels`),
        axios.get(`${apiUrl}/banners`)
      ]);

      setProducts(productsRes.data);
      setCategories(categoriesRes.data.categories);
      setPixel(pixelRes.data.pixels?.map((p)=>p.pixel_id) || '');
      setBanners(bannersRes.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, [apiUrl]);

  return (
    <ProductContext.Provider
      value={{
        products,
        categories,
        pixel,
        banners,
        loading,
        setLoading,
        error,
        refetchData: fetchAllData,
        apiUrl
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};